import React from "react";
import { Link } from "react-router-dom";
import CONSTANT from "./../../constant";
import Loader from "./../../component/common/Loader";
import { getAppraisalCycleById, editAppraisalCycle } from "../../actions/AppraisalCycleAction";

class EditAppraisalCycle extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      code: props.match.params.code,
      showLoader: false,
      isMouApplicable: { name: "isMouApplicable", value: "", error: "", isRequired: true },
      cycleName:        { name: "cycleName",        value: "", error: "", isRequired: true },
      financialYear:    { name: "financialYear",    value: "", error: "", isRequired: true },
      startDate:        { name: "startDate",        value: "", error: "", isRequired: true },
      endDate:          { name: "endDate",          value: "", error: "", isRequired: true },
      status:           { name: "status",           value: "Draft", error: "", isRequired: true },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Edit Appraisal Cycle - " + CONSTANT.organisation.name;
    this.loadDetail();
  }

  loadDetail = () => {
    const { code } = this.state;
    this.setState({ showLoader: true });

    getAppraisalCycleById(code).then((res: any) => {
      this.setState({ showLoader: false });

      if (!res || !res.result) return;

      const d = res.result;

      const fmt = (val: string) =>
        val ? new Date(val).toISOString().split("T")[0] : "";

      this.setState({
        isMouApplicable: { ...this.state.isMouApplicable, value: String(d.is_mou_applicable) },
        cycleName:       { ...this.state.cycleName,        value: d.cycle_name      || "" },
        financialYear:   { ...this.state.financialYear,    value: d.financial_year  || "" },
        startDate:       { ...this.state.startDate,        value: fmt(d.start_date)       },
        endDate:         { ...this.state.endDate,          value: fmt(d.end_date)         },
        status:          { ...this.state.status,           value: d.status          || "Draft" },
      });
    });
  };

  render() {
    const {
      isMouApplicable, cycleName, financialYear,
      startDate, endDate, status, showLoader,
    } = this.state;

    const mouYes      = isMouApplicable.value === "true";
    const mouSelected = isMouApplicable.value !== "";

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-12">
                    <h1 className="page-title">Edit Appraisal Cycle</h1>
                  </div>
                </div>

                <form onSubmit={this.onSubmit}>

                  {/* ── MoU & Weightage ── */}
                  <div className="row mb-2">
                    <div className="col-md-12">
                      <h5 className="text-muted">
                        <i className="fa fa-balance-scale mr-2" />
                        MoU &amp; Weightage
                      </h5>
                      <hr />
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Is MoU Applicable?</label>
                        <input
                          type="text"
                          className="form-control"
                          value={isMouApplicable.value === "true" ? "Yes" : isMouApplicable.value === "false" ? "No" : ""}
                          readOnly
                        />
                      </div>
                    </div>

                    {mouSelected && (
                      <div className="col-md-9">
                        <div className={`alert mb-0 ${mouYes ? "alert-info" : "alert-warning"}`}>
                          <i className="fa fa-info-circle mr-2" />
                          {mouYes
                            ? "Weightage: 20% MoU + 55% KPAs"
                            : "Weightage: 75% KPAs only"}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* ── Basic Details ── */}
                  <div className="row mb-2 mt-4">
                    <div className="col-md-12">
                      <h5 className="text-muted">
                        <i className="fa fa-info-circle mr-2" />
                        Basic Details
                      </h5>
                      <hr />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Cycle Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={cycleName.value}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Appraisal Cycle Year</label>
                        <input
                          type="text"
                          className="form-control"
                          value={financialYear.value}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Status <span className="text-danger">*</span></label>
                        <select
                          className={status.error ? "form-control is-invalid" : "form-control"}
                          name={status.name}
                          value={status.value}
                          onChange={this.onChange}
                        >
                          <option value="Draft">Draft</option>
                          <option value="Active">Active</option>
                          <option value="Completed">Completed</option>
                        </select>
                        {status.error && <div className="invalid-feedback">{status.error}</div>}
                      </div>
                    </div>
                  </div>

                  {/* ── Assessment Period ── */}
                  <div className="row mb-2 mt-3">
                    <div className="col-md-12">
                      <h5 className="text-muted">
                        <i className="fa fa-calendar mr-2" />
                        Assessment Period
                      </h5>
                      <hr />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Cycle Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDate.value}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Cycle End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={endDate.value}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  {/* ── Action Buttons ── */}
                  <div className="row mt-4">
                    <div className="col-md-3">
                      <Link
                        to={CONSTANT.component.startAppraisalCycle.url}
                        className="btn btn-block cancel-button btn-sm"
                      >
                        Cancel
                      </Link>
                    </div>
                    <div className="col-md-6" />
                    <div className="col-md-3">
                      <button type="submit" className="btn btn-block submit-button btn-sm">
                        Update Cycle
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {showLoader && <Loader />}
      </div>
    );
  }

  onChange = (e: any) => {
    const { name, value } = e.target;
    this.setState((prev: any) => ({
      [name]: { ...prev[name], value, error: "" },
    }));
  };

  validateForm = () => {
    const { status } = this.state;
    let isValid = true;

    if (!status.value) {
      this.setState((p: any) => ({ status: { ...p.status, error: "Status is required" } }));
      isValid = false;
    }

    return isValid;
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateForm()) return;

    this.setState({ showLoader: true });
    const st = this.state;
    const mouYes = st.isMouApplicable.value === "true";

    const model = {
      code:            st.code,
      isMouApplicable: mouYes,
      mouWeightage:    mouYes ? 20 : 0,
      kpaWeightage:    mouYes ? 55 : 75,
      otherWeightage:  25,
      cycleName:       st.cycleName.value,
      financialYear:   st.financialYear.value,
      startDate:       st.startDate.value,
      endDate:         st.endDate.value,
      status:          st.status.value,
    };

    editAppraisalCycle(model).then((res: any) => {
      this.setState({ showLoader: false });

      if (res && res.status === CONSTANT.static.apiStatus.success) {
        this.props.history.push(CONSTANT.component.startAppraisalCycle.url);
      } else {
        alert(res?.error || "Failed to update appraisal cycle");
      }
    });
  };
}

export default EditAppraisalCycle;